module.exports = __webpack_public_path__ + "static/media/logo-cnnturk@3x.db894f15.png";